<template>
  <div id="salemarket">
    <my-header></my-header>
    <div class="pd10">
      <div id="sale-market" class="sale-market">
        <sale-market-head></sale-market-head>
        <ol class="breadcrumb" v-if="product">
          <li>
            <router-link :to="{ name: 'SaleMarket', params: { }}">{{'Sale Market'|translate}}</router-link>
          </li>
          <li>
          {{product.name}}
          
          </li>
          <li>{{varriant_name}}</li>
        </ol>
        <loading class="mt10" :text="'Please wait'|translate" v-if="list_items ===null"></loading>
        <p
          class="mt10 alert alert-warning"
          v-if="list_items && list_items.length == 0"
        >{{'No result'|translate}}</p>
        <div v-if="list_items && list_items.length >0" class="list-results row">
          <div class="item col-md-6" v-for="item in list_items" :key="item.id">
            <div class="media mb20">
              <div class="media-left">
                <img :src="item.product_feature_image" class="media-object" style="width:80px" />
              </div>
              <div class="media-body">
                <h4 class="media-heading mb10">
                  <router-link
                    :to="{ name: 'SaleAdMarketDetail', params: { ad_id: item.id}}"
                  >{{item.varriant_name}}: {{toCommas(item.price)}}{{'price_unit'|translate}}/{{item.unit_name}}</router-link>
                </h4>
                <p>
                  <i class="fas fa-store-alt"></i>
                  {{item.store_name}}
                <br/>
                      <i class="fas fa-truck"></i>
                      {{item.source_name}} ({{item.source_type|translate}})
                    </p>
              </div>
            </div>
          </div>
          <!-- end item  -->
        </div>
        <paginate
          v-if="total_page > 1"
          :page-count="total_page"
          :click-handler="clickPage"
          :prev-text="'Prev'|translate"
          :next-text="'Next'|translate"
          v-model="page"
          :container-class="'pagination'"
        ></paginate>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import Paginate from "vuejs-paginate";
import SaleMarketHead from "@/components/SaleMarket/SaleMarketHead";
export default {
  name: "SaleMarket",
  components: {
    MyHeader,
    Loading,
    Paginate,
    SaleMarketHead
  },
  data() {
    let data = {
      product_id: null,
      product: null,
      varriant_id: null,
      list_items: null,
      total_page: 1,
      page: 1,
      search_params: {
        product_id: "",
        varriant_id: "",

        limit: Utils.getLimit(),
        offset: 0
      }
    };

    return data;
  },

  methods: {
    toCommas(value) {
      return Utils.toCommas(value);
    },
    list() {
      this.working = true;

      this.list_items = null;

      Utils.request(this, true, "salemarket")
        .get(`/listAds/?${Utils.arrayToRequestParam(this.search_params)}`)
        .then(response => {
          let data = response.data;
          this.working = false;
          if (data.status === "ok") {
            let list = data.data.list;

            this.list_items = list;
            this.total_page = Utils.getTotalPages(data.data.total);
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    getActiveProduct() {
      Utils.getAllProducts(this, {}).then(data => {
        var allProducts = data;

        var products = allProducts.filter(item => {
          return item.id == this.search_params.product_id;
        });

        if (products.length > 0) {
          this.product = products[0];
        }
      });
    }
  },
  mounted() {
    this.search_params.product_id = this.$route.params.product_id;
    this.varriant_name = this.$route.params.varriant_name;
    this.search_params.varriant_id = this.$route.params.varriant_id;

    this.list();
    this.getActiveProduct();
  },
  beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/SaleMarketVarriant.vue